exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-26b8d766]::-webkit-inner-spin-button,input[data-v-26b8d766]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-26b8d766]{-moz-appearance:textfield}.tanpawrap[data-v-26b8d766]{white-space:nowrap}", ""]);

// exports
